export function isDigitalProduct(product: { productType: string }): boolean {
  // `digitalCard` = premium digital. `digital` and `basicDigitalV2` = the synthetic
  // free products (see `freeDigitalProduct`); the backend never returns either
  // productType, so those only classify the injected dummies. All three are digital.
  return product.productType === 'digitalCard' || product.productType === 'digital' || product.productType === 'basicDigitalV2';
}
